<template>
    <div>
        <div v-if="modalData.status !== ResponseStatus.success">
            <div class="notice">
                {{ $t('Something went wrong. Please try again') }}
            </div>
            <Illustration xl image="/static/img/illustrations/withdrawal__error.svg"/>
        </div>
        <div v-else-if="modalData.status === ResponseStatus.success && !modalData.redirectUrl">
            <Illustration xl image="/static/img/illustrations/withdrawal__success.svg"/>
            <div class="notice">
                {{ $t('The transaction will be processed as soon as possible.') }}
            </div>
        </div>
        <iframe
            v-else
            :src="modalData.redirectUrl"
            id="iframe-content"
            :width="iframeWidth"
            :height="iframeHeight"
            style="overflow:hidden; border:none; margin:0; margin-top: 0; "
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import config from '@config';
    import { ResponseStatus } from '@core/models/user/withdrawal/enums';

    export default {
        name: 'OnlineWithdrawalResponseModal',
        data() {
            return {
                iframeHeight: config.app.user.withdrawal.iframeHeight,
                iframeWidth: config.app.user.withdrawal.iframeWidth,
            };
        },
        created() {
            this.ResponseStatus = ResponseStatus;
        },
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
        },
    };
</script>

<style>
    .withdrawal_modal {
        width: 800px;
        max-width: 800px;
        max-height: 1400px;
    }
</style>



// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/withdrawal/OnlineWithdrawalResponseModal.vue